import { render, staticRenderFns } from "./threejs11.vue?vue&type=template&id=d421be2c&scoped=true"
import script from "./threejs11.vue?vue&type=script&lang=js"
export * from "./threejs11.vue?vue&type=script&lang=js"
import style0 from "./threejs11.vue?vue&type=style&index=0&id=d421be2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d421be2c",
  null
  
)

export default component.exports